ScrollableView = require("../scrollable/view")
Preloader      = require("lib/preload")
{ dpi, platform }        = require("lib/device")
Constants      = require("./constants")
{ Actions }    = require("./actions")
Data           = require("./data")

class PeerAuthoringView extends ScrollableView
  template: require("./template")
  mediaItemTemplate: require("./media-item")
  ignoreStateOnRefresh: true

  initialize: ->
    super
    # Create the action creator for this slide, this auto adds the slide Id to the payload
    if window.ED_LMS_PREVIEW or window.ED_PUBLIC_PREVIEW or not __?.slidedeck?
      @actions = new Actions("", "")
    else
      @actions = new Actions(__.slidedeck.id, @id)
    @media = []
    @upload = {
      progress: 0
      uri: null
      isUploading: false
    }
    # WARNING: Make sure to only use this when debugging
    # window._pa = this

  # serialize: -> super

  events: ->
    # Example of event handler
    _.extend super,
      "iostap .btn-done": "next"
      "iostap .js-upload": "onUpload"
      "iostap .js-submit-button": "onSubmit"
      "iostap .js-like-button": "onLike"
      "click .js-comment-button": "onComment"
      "focus .js-title-input": "onTitleInputFocus"
      "focusout .js-title-input": "onTitleInputBlur"

  renderItem: (item) =>
    # Build thumbnail url via cloudinary if not supplied from server
    videoThumbnail = item.thumbnail
    if not videoThumbnail and item.url and /cloudinary.*\..{3,4}$/.test(item.url)
      videoThumbnail = item.url.replace /\..{3,4}$/, ".jpg"

    item = {
      id: item.id
      type: 'video'
      url: item.url
      title: item.title
      commentCount: item.commentCount
      thumbnail: videoThumbnail
    }
    @mediaItemTemplate({ item, config: @options.config() })

  prependItem: (item) -> @getEl("item_list").prepend @renderItem(item)

  getMediaForSlide: ->
    if window.ED_LMS_PREVIEW or window.ED_PUBLIC_PREVIEW
      # Use a placeholder dataset for CMS or testing
      @getMediaForSlideSuccess(Data.getNoMediaForSlideData())
    else
      @actions.getMediaForSlide()
      @getEl("loading_view").removeClass("hidden")
      @getEl("item_list").addClass("hidden")
      @getEl("no_media_view").addClass("hidden")

  getMediaForSlideSuccess: (payload) =>
    # Thomas gives us media stuff
    items = payload.items
    totalCount = payload.totalCount
    videoId = payload.videoId
    @getEl("loading_view").addClass("hidden")
    if totalCount is 0
      @getEl("no_media_view").removeClass("hidden")
      @getEl("item_list").addClass("hidden")
    else
      @media = items
      @getEl("no_media_view").addClass("hidden")
      @getEl("item_list").removeClass("hidden").html @media.map(@renderItem).join("")
      window.setTimeout((=> @preloadMedia()), 1000)
      if payload.openComment
        window.setTimeout((=> @autoOpenComment(videoId)), 2000)

  autoOpenComment: (videoId) =>
    # simulate the button click of comment icon
    commentItem = $("ul.slide-content").find("[data-id=\'#{videoId}\']")
    button = $(commentItem).find('.js-comment-button')
    button.trigger('click')

  uploadMediaFromSourcePreview: ({ uri }) =>
    @upload.uri = uri
    @getEl("loading_indicator").removeClass("hidden")

  uploadMediaFromSourceProgress: ({ percent }) =>
    @upload.percent = percent
    if typeof percent is "number"
      if percent is 1
        @getEl("progress").html "Processing..."
      else
        @getEl("progress").html("Uploaded #{(percent * 100).toFixed()}%")

  uploadMediaFromSourceSuccess: ({ uri }) =>
    @upload = { uri, progress: undefined, isUploading: false }
    @getEl("progress").html i18n("peer-authoring.upload-complete")
    @getEl("upload_form").removeClass("hidden")
    @getEl("loading_indicator").addClass("hidden")
    @getEl("upload_complete_indicator").removeClass("upload-progress-indicator--hidden")

  uploadMediaFromSourceFailure: ({ message }) =>
    @upload = { uri: undefined, progress: undefined, isUploading: false }
    @showContentView()

  postMediaForSlideSuccess: (payload) =>
    @prependItem(payload)
    # The initial video upload we need to make sure content is visible
    @getEl("loading_view").addClass("hidden")
    @getEl("content_view").removeClass("hidden")
    $(".js-no-media-view").addClass("hidden")
    $(".js-item-list").removeClass("hidden")
    window.setTimeout((=> @preloadMedia()), 400)
    contentScroll = @findOne(".content-scroll")
    $li = $("[data-id=#{payload.id}]")
    # contentScroll.scrollTo({ top: $li[0].offsetTop + 10, behavior: "smooth" })
    window.setTimeout((=> contentScroll.scrollTo({ top: $li[0].offsetTop + 10, behavior: "smooth" })), 1000)

  exitSocialLearning: (e) =>
    $(".selected").removeClass("selected")

  handleCommentAdded: (e) =>
    contentId = e.payload.contentId
    commentCount = $("[data-id='#{contentId}']").find(".js-video-comment-count")
    commentCountString = commentCount.text()
    if commentCountString
      commentCount.text((parseInt commentCountString, 10) + 1)

  show: ->
    super
    # Get videos from Hippo
    @setEl $(".js-item-list"), "item_list" # The container for where videos get inserted
    @setEl $(".js-upload-view"), "upload_view" # The upload view where users submit video
    @setEl $(".js-content-view"), "content_view" # The main view showing videos
    @setEl $(".js-loading-view"), "loading_view" # The loading view
    @setEl $(".js-no-media-view"), "no_media_view" # When the slide has no uploaded content
    @setEl $(".js-title-input"), "title_input" # The input field for the title
    @setEl $(".js-progress"), "progress" # The progress indicator text for the percentage
    @setEl $(".js-upload-form"), "upload_form" # Contains the title and submit button
    @setEl $(".js-upload"), "upload_button" # Activates the media picker and shows upload view
    @setEl $(".js-loading-indicator"), "loading_indicator" # Loading indicator
    @setEl $("#slides"), "slides" # Container for slides.
    @setEl $(".slide-footer"), "slide_footer"# Used to hide page footer in upload view
    @setEl $(".js-progress-indicator"), "upload_complete_indicator" # Big 100% circle

    @getMediaForSlide()
    # Un-hide the upload button on platforms other than the browser
    if platform isnt "browser"
      @getEl("upload_button").removeClass("hidden")
    @delegateEventsOnShow()

  delegateEventsOnShow: ->
    # Bind events here, they get destroyed otherwise
    @listenTo Backbone.Events, Constants.COMMENT_ADDED, @handleCommentAdded
    @listenTo Backbone.Events, Constants.GET_MEDIA_FOR_SLIDE_SUCCESS, @getMediaForSlideSuccess
    @listenTo Backbone.Events, Constants.UPLOAD_MEDIA_FROM_SOURCE_PREVIEW, @uploadMediaFromSourcePreview
    @listenTo Backbone.Events, Constants.UPLOAD_MEDIA_FROM_SOURCE_PROGRESS, @uploadMediaFromSourceProgress
    @listenTo Backbone.Events, Constants.UPLOAD_MEDIA_FROM_SOURCE_SUCCESS, @uploadMediaFromSourceSuccess
    @listenTo Backbone.Events, Constants.UPLOAD_MEDIA_FROM_SOURCE_FAILURE, @uploadMediaFromSourceFailure
    @listenTo Backbone.Events, Constants.POST_MEDIA_FOR_SLIDE_SUCCESS, @postMediaForSlideSuccess
    @listenTo Backbone.Events, "social-learning:exit", @exitSocialLearning

  # onRefresh: -> @show()

  onScroll: (e) ->
    super

    if platform isnt "browser"
      scrollTop = e.srcElement.scrollTop
      uploadBtn = @getEl("upload_button")

      if scrollTop > 40 && !uploadBtn.hasClass("btn-upload--hidden")
        uploadBtn.addClass("btn-upload--hidden")
        _.delay (-> uploadBtn.addClass("hidden")), 550
      else if scrollTop <= 40 && uploadBtn.hasClass("btn-upload--hidden")
        uploadBtn.removeClass("hidden")
        _.delay (-> uploadBtn.removeClass("btn-upload--hidden")), 5

  onUpload: =>
    if window.ED_LMS_PREVIEW or window.ED_PUBLIC_PREVIEW or platform is "browser"
      return
    @upload.isUploading = true
    @showUploadView()
    # Present the device image picker
    @actions.uploadMediaFromSource("library", "video")

  onSubmit: (e) =>
    e.preventDefault()
    @showContentView()
    @actions.postMediaForSlide({ url: @upload.uri, title: @getEl("title_input").val() })
    false

  onComment: (e) =>
    if window.ED_LMS_PREVIEW or window.ED_PUBLIC_PREVIEW
      return
    $li = $(e.currentTarget).parents("li")
    $li.addClass("selected")
    contentScroll = @findOne(".content-scroll")
    # transitionEnd = ->
    #   contentScroll.scrollTo({ top: $li[0].offsetTop + 10, behavior: "smooth" })
    #   $li[0].removeEventListener "transitionend", transitionEnd
    # $li[0].addEventListener "transitionend", transitionEnd

    window.setTimeout ->
      contentScroll.scrollTo({ top: $li[0].offsetTop + 10, behavior: "smooth" })
    , 600
    id = $li.data("id").toString()
    Backbone.Events.trigger("open-social-learning", { slide: @, peerAuthoring: true, contentId: id })
    @actions.unsetAutoOpenComment()

  onTitleInputFocus: =>
    @getEl("upload_complete_indicator").addClass("upload-progress-indicator--hidden")

  onTitleInputBlur: =>
    @getEl("upload_complete_indicator").removeClass("upload-progress-indicator--hidden")

  onLike: =>
    # TODO: Implement (also on server side)

  showUploadView: =>
    @getEl("progress").html i18n("peer-authoring.uploading")
    @getEl("upload_form").addClass("hidden")
    @getEl("loading_indicator").removeClass("hidden")
    @getEl("upload_button").addClass("hidden")
    @getEl("content_view").addClass("hidden")
    @getEl("upload_view").removeClass("hidden")
    @getEl("title_input").val("")
    @getEl("upload_complete_indicator").addClass("upload-progress-indicator--hidden")
    @hideSlideFooter()

  showContentView: =>
    @getEl("upload_view").addClass("hidden")
    @getEl("upload_form").addClass("hidden")
    @getEl("upload_button").removeClass("hidden")
    @getEl("content_view").removeClass("hidden")
    @showSlideFooter()

  hideSlideFooter: =>
    @getEl("slide_footer").css("display", "none")
    @getEl("slides").css("border-bottom", "none")

  showSlideFooter: =>
    @getEl("slide_footer").css("display", "block")
    @getEl("slides").css("border-bottom", "solid 1px currentColor")

  # When the slide is going out of user's view
  hide: ->
    @showSlideFooter()

module.exports = PeerAuthoringView
